export type IExternalServices = {
  _id?: string;
  companyId?: string;
  createdAt?: Date;
  licensePlate?: string;
  description: string;
  totalValue: number;
  supplierName: string;
  status?: string;
}

export const emptyExternalServices = () => ({
  _id: "",
  companyId: "",
  licensePlate: "",
  description: "",
  totalValue: 0,
  supplierName: "",
})

export enum EXTERNAL_SERVICE_STATUS {
  'PENDENTE' = 'Pendente',
  'PRE_APROVADO' = 'Pré-Aprovado',
  'APROVADO' = 'Aprovado',
  'CANCELADO' = 'Cancelado'
}

